import { useAuth } from '@/contexts/AuthContext';
import PartnerApprovalsPanel from '@/components/partners/PartnerApprovalsPanel';

export default function PartnerApprovalsPage() {
  const { isChainAdmin } = useAuth();
  return (
    <div className="p-6">
      <PartnerApprovalsPanel
        mode={isChainAdmin ? 'chain' : 'hospital'}
        canApprove={isChainAdmin}
        canApprovePartner
      />
    </div>
  );
}
